export * from "./adapter-total-actual-hours-summary.interface";
